import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useEffect, useRef } from "react";

type SortableRowProps = {
  id: string;
  disabled?: boolean;
  children: (dragHandleProps: any) => React.ReactNode;
};

const SortableRow = ({ id, disabled, children }: SortableRowProps) => {
  const preStyleRef = useRef<{
    transform: string | undefined;
    transition: string | undefined;
  }>();
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled });

  const style =
    !transform && isDragging
      ? preStyleRef.current
      : {
          transform: CSS.Translate.toString({
            x: 0,
            y: transform?.y || 0,
            scaleX: 1,
            scaleY: 1,
          }),
          transition,
        };

  useEffect(() => {
    preStyleRef.current = style;
  }, [style]);

  return (
    <div
      ref={setNodeRef}
      style={{ ...style, zIndex: isDragging ? 1 : 0, position: "relative" }}
      className={isDragging ? "is-dragging" : ""}
      {...attributes}
    >
      {children(listeners)}
    </div>
  );
};

export default SortableRow;
